import { connectDeep } from 'redux-utils';

import App from '../../models/app';
import { fetchCollection } from '../../actions/registry/index';
import { Collection } from '../../components/v2/Collection';
import { VirtualizedClockList } from '../../components/v2/ClockList/VirtualizedClockList';
import { VirtualizedAppList } from '../../components/v2/AppList/VirtualizedAppList';
import { getType } from '../../utils.v2';

const APP_DIGEST_PROPS = {
  showInstalled: true
};

interface Params {
  id: string;
}

const mapStateToProps = (state: any, { id }: Params) => {
  const { isApp, appType } = getType();
  const {
    collections,
    fetchCollection: { loading },
    installed: {
      error,
    },
    galleryGrant: { userHasGrant, loading: loadingHasGalleryGrant }
  } = state.registry;

  const {
    deeplinkStatus: { isOpen: deeplinkIsOpen }
  } = state.gallery;

  const collection = collections[id] || {};
  const apps = collection.appIds
    ? collection.appIds.map((appId: string) => App.selectFromState(appId, state))
    : [];
  const userFlags = collection.userFlags || [];

  const getListPage = () => {
    if (appType === 'CLOCK') {
      return VirtualizedClockList;
    }

    return VirtualizedAppList
  }
  const ListPage = getListPage();

  return {
    appDigestProps: APP_DIGEST_PROPS,
    apps,
    isApp,
    collection,
    hasNextPage: collection.hasNextPage,
    error,
    loading: loading || loadingHasGalleryGrant || deeplinkIsOpen,
    userHasGalleryGrant: userHasGrant,
    ListPage,
    userFlags,
  };
};

const mapDispatchToProps = {
  fetchMore: fetchCollection
};

export default connectDeep(mapStateToProps, mapDispatchToProps)(Collection);
